import React from "react";
import classes from "./counter.module.scss";

const Counter = ({ onChangeHandler, item, index, parentData, placeholder, value }) => {
  return (
    <div className={classes.counter_counter_container}>
      <div
        onClick={() => {
          if (value - item?.multiplier !== 0) {
            onChangeHandler(value - item?.multiplier, item, index, parentData);
          }
        }}
        className={`${classes.counter_counter_button} ${value - item?.multiplier === 0 ? "disabled_button" : ""}`}
      >
        -
      </div>
      <div className={classes.counter_counter_input}>{item?.value}</div>
      <div
        onClick={() => {
          if (value < item?.maximum_value) {
            onChangeHandler(value + item?.multiplier, item, index, parentData);
          }
        }}
        className={`${classes.counter_counter_button}  ${value === item?.maximum_value ? "disabled_button" : ""}`}
      >
        +
      </div>
    </div>
  );
};

export default Counter;
